module.exports = __webpack_public_path__ + "img/comment-light.3c863fb6.svg";